import { Component, Input, OnInit } from "@angular/core";
import { NbDialogService } from "@nebular/theme";
import { CompanyUser } from "src/app/models/company-user.model";
import { UserService } from "src/app/services/user.service";
import { UserEditDialogComponent } from "../user-edit-dialog/user-edit-dialog.component";
import { UserDeleteDialogComponent } from "../user-delete-dialog/user-delete-dialog.component";
import { getAnimalTypesLabel } from "src/app/constants/animal-types.constants";

export type UserManagementContext = "admin" | "breederadmin";

@Component({
    selector: "app-user-list",
    templateUrl: "./user-list.component.html",
    styleUrls: ["./user-list.component.scss"],
    standalone: false
})
export class UserListComponent implements OnInit {
  @Input() context: UserManagementContext;
  @Input() companyId: number;

  public users: CompanyUser[] | null = null;
  public loading = false;

  constructor(
    private userService: UserService,
    private dialogService: NbDialogService,
  ) {}

  ngOnInit(): void {
    this.refreshUsers();
  }

  private refreshUsers(): void {
    if (!this.companyId) return;

    this.loading = true;
    this.userService.getCompanyUsers(this.companyId).subscribe((users) => {
      this.users = users;
      this.loading = false;
    });
  }

  public canEdit(user: CompanyUser): boolean {
    if (user.invitationDeclinedAt) {
      return false;
    }

    if (this.context === "admin") {
      // Admin can only edit internal roles (breeder/breederadmin)
      return user.isInternalRole();
    } else {
      // Breederadmin can edit all users (including breederadmin, but with restrictions)
      return true;
    }
  }

  public canDelete(user: CompanyUser): boolean {
    if (this.context === "admin") {
      // Admin can remove ANY user from a company
      return true;
    } else {
      // Breederadmin can delete all except breederadmin
      return user.role !== "breederadmin";
    }
  }

  public addUserAction(): void {
    this.dialogService
      .open(UserEditDialogComponent, {
        context: {
          context: this.context,
          companyId: this.companyId,
        },
        dialogClass: "dialog-min-width",
      })
      .onClose.subscribe(() => {
        this.refreshUsers();
      });
  }

  public editUserAction(user: CompanyUser): void {
    this.dialogService
      .open(UserEditDialogComponent, {
        context: {
          context: this.context,
          companyId: this.companyId,
          user: user,
        },
        dialogClass: "dialog-min-width",
      })
      .onClose.subscribe(() => {
        this.refreshUsers();
      });
  }

  public deleteUserAction(user: CompanyUser): void {
    this.dialogService
      .open(UserDeleteDialogComponent, {
        context: {
          context: this.context,
          companyId: this.companyId,
          user: user,
        },
      })
      .onClose.subscribe((response) => {
        if (response?.deleted) {
          this.refreshUsers();
        }
      });
  }

  public getAnimalTypesLabel(animalTypeIds: number[] | undefined): string {
    return getAnimalTypesLabel(animalTypeIds);
  }
}
